export default __webpack_public_path__ + "static/Faith-558b610a19667761728f5b78dc50caf0.pdf";